<template>
    <v-card flat class="ma-4 pa-3" color="transparent">
      <v-layout class="mt-2">
        <v-flex xs1 class="pt-2"><v-icon>info</v-icon></v-flex>
        <v-flex xs11>
          <p class="subheading">
            Leider kein automatischer Standort verfügbar.<br>
            Bitte wählen Sie den Ausgangspunkt aus:
          </p>
      </v-flex>
      </v-layout>
      
    
      <v-autocomplete
        v-bind:items="staedteleer"
        item-value="id"
        v-model="Stadt"
        required
        solo
        label="Stadt auswählen"
        name="Stadt"
        :loading="isLoading"
        browser-autcomplete="off"
        prepend-inner-icon="location_searching"
        no-data-text
        class="mr-2"
        validate-on-blur
        data-vv-name="Stadt"
        @change="StadtWahl()"
        return-object
        cache-items
        item-text="name"
      ></v-autocomplete>    
      <!-- <v-btn @click="getStaedte()">laden</v-btn> -->
      <!-- {{ location }} {{ this.$store.getters.fetchBetriebe.standortwert[0] }} -->
    </v-card>

</template>


<script>
import axios from 'axios'
// import StartseiteMap from '~/pages/StartseiteMap'
// import { mapGetters } from 'vuex'
import { mapActions } from 'vuex'

export default {

  components: {
  },
  props: ['location'],
  data: () => ({
    isLoading: false,
    Stadt: '',
    staedteleer: []
  }),
  computed: {
    // liste_betriebe () {
    //   return this.$store.state.suche
    // }
  },
  mounted: function () {
    // this.CheckObVuexLeer()
    this.getStaedte()
    console.log('wählen mounted')
  },
  created () {
    // this.neuGEOIP();

  },
  methods: {
    // validate () {
    // 	this.$validator.validate();
    // },
    toggleMap: function () {
      this.zeigekarte = true
    },
    ...mapActions({
      changeHeimatStadt: 'setStadt' // map `this.add()` to `this.$store.dispatch('increment')`
    }),
    StadtWahl: function () {
      this.$store.dispatch('neueGeolocatePosiVonStadtWahlButton', this.Stadt)
      this.$emit('StadtGewaehlt', this.Stadt)
    },
    getStaedte: function () {
      this.isLoading = true
      const self = this
      axios
      .get('/api/v1/staedteliste')
      .then(resp => {
        console.log(resp.data)
        // self.leistungenleer = resp.data.leistungen
        self.staedteleer = resp.data
      })
      .catch(err => {
        console.log(err)
        this.isLoading = false
      })
      .finally(() => (this.isLoading = false))
    }
  }
}
</script>

<style >
</style>